import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormMultiSelect from "../form/FormMultiSelect";
import TmwApi from "../../containers/Ticket/TmwApi";

class TmwInvoiceStatusSelect extends PureComponent {
	render () {
		const { value, useOrderStatuses} = this.props;
		let options = [
			{ value : 'AVL', display : 'AVL'},
			{ value : 'CAN', display : 'CAN'},
			{ value : 'HLA', display : 'HLA'},
			{ value : 'HLD', display : 'HLD'},
			{ value : 'PRN', display : 'PRN'},
			{ value : 'RTP', display : 'RTP'},
		];

		if (useOrderStatuses) {
			options = [
				{ value : 'AVL', display : 'AVL'},
				{ value : 'HLA', display : 'HLA'},
				{ value : 'HLD', display : 'HLD'},
			];
		}
		options = _.sortBy(options, 'display');

		return (
			<FormMultiSelect
				{...this.props}
				// so an empty thing doesn't flicker in
				value={value}
				options={options}
			/>
		);
	}
}

TmwInvoiceStatusSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.array,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,
	classes : PropTypes.object,
	helpText : PropTypes.string,
	useOrderStatuses : PropTypes.bool,
};

TmwInvoiceStatusSelect.defaultProps =  {
	label : 'Invoice Statuses',
};

export default TmwApi(TmwInvoiceStatusSelect);
